module.exports = __webpack_public_path__ + "img/jujue.b4bdfec9.png";